var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49999 0.00166228C2.08415 -0.0619083 0.0701575 1.70575 0.00172206 3.94986C-0.000172352 4.01376 -0.000527597 4.07766 0.000774808 4.14145C0.000774808 7.60813 4.16847 10.8153 4.3437 10.9471C4.43227 11.0176 4.56286 11.0176 4.65143 10.9471C4.83625 10.7933 8.99921 7.26498 8.99921 4.14145C9.04468 1.89679 7.12256 0.0429061 4.70613 0.00078241C4.63745 -0.00042741 4.56866 -0.000207443 4.49999 0.00166228ZM4.49999 6.16075C3.32297 6.16075 2.36878 5.27439 2.36878 4.18104C2.36878 3.08769 3.32297 2.20134 4.49999 2.20134C5.67701 2.20134 6.6312 3.08769 6.6312 4.18104C6.6312 5.27439 5.67701 6.16075 4.49999 6.16075Z",
    fill: "#283686"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceRound);
export default __webpack_public_path__ + "static/media/PlaceRound.55a13ca5.svg";
export { ForwardRef as ReactComponent };